/**
 * @flow
 * @relayHash c7101b58769e75a5f841ed19fe3b320b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BulkReviewMutationVariables = {|
  documentPks?: ?$ReadOnlyArray<?number>,
  comment: string,
|};
export type BulkReviewMutationResponse = {|
  +bulkReview: ?{|
    +taskId: ?string
  |}
|};
export type BulkReviewMutation = {|
  variables: BulkReviewMutationVariables,
  response: BulkReviewMutationResponse,
|};
*/


/*
mutation BulkReviewMutation(
  $documentPks: [Int]
  $comment: String!
) {
  bulkReview(documentPks: $documentPks, comment: $comment) {
    taskId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "documentPks",
    "type": "[Int]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "comment",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "bulkReview",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "comment",
        "variableName": "comment",
        "type": "String!"
      },
      {
        "kind": "Variable",
        "name": "documentPks",
        "variableName": "documentPks",
        "type": "[Int]"
      }
    ],
    "concreteType": "BulkReviewMutation",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "taskId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "BulkReviewMutation",
  "id": "08f5857ac1bcc82e429d7d5ad503fd94",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "BulkReviewMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "BulkReviewMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
node.text = "mutation BulkReviewMutation(\n  $documentPks: [Int]\n  $comment: String!\n) {\n  bulkReview(documentPks: $documentPks, comment: $comment) {\n    taskId\n  }\n}\n";
(node/*: any*/).hash = '5c3141e8f105357586c0783db8f94d8c';
module.exports = node;
